import {
    CloudUploadOutlined as CloudUploadOutlinedIcon,
    FeedbackOutlined as FeedbackOutlinedIcon
} from '@material-ui/icons';
import {
    Backdrop,
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Fade,
    FormGroup,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import { ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { formatData, formatTime } from 'lib/functions';
import PerfectScrollBar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class AgendaEscalaFornecedorForm extends Component {
    state = {
        escala: null,
        itens: [],
        isLoading: true,
        isView: false,
        configPartner: {},
        kminicial: '',
        kmfinal: '',
        fotoKmInicial: null,
        fotoKmFinal: null,
        isImageModalOpen: false,
        imageModalSrc: '',
        imageModalAlt: '',
        openAlert: false,
        messageAlert: '',
        openObsModal: false,
        obsModalTexto: '',
        obsModalTitulo: '',
        openPaxModal: false,
        paxModalTitulo: '',
        paxModalTotal: 0,
        paxModalItens: [],
        paxModalGeral: false
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const isView = location && location.pathname && location.pathname.includes('/view');

        try {
            await this.loadAgendaEscalaFornecedor(id, isView);
        } catch (error) {
            console.error('Erro ao carregar agenda de escala do fornecedor:', error.response?.data || error.message);

            this.setState({
                escala: null,
                itens: [],
                isLoading: false
            });

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar detalhes da escala!'
            );
        }
    };

    /* Carrega a agenda de escalas do fornecedor */
    loadAgendaEscalaFornecedor = async (id, isView) => {
        const responseEscala = await api.get(`/agendaescalafornecedor/${id}`);
        const escala = responseEscala?.data?.data?.[0] || null;
        const configPartnerRaw = responseEscala?.data?.configPartner || {};

        const configPartner = Object.fromEntries(
            Object.entries(configPartnerRaw).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.trim() : value
            ])
        );

        const responseItens = await api.get(`/agendaescalafornecedor/${id}/itens`);
        const itens = responseItens?.data?.data || [];

        this.setState({
            escala,
            itens,
            isLoading: false,
            isView,
            configPartner,
            kminicial: escala && escala.kminicial != null ? String(escala.kminicial) : '',
            kmfinal: escala && escala.kmfinal != null ? String(escala.kmfinal) : ''
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de agenda de escala do fornecedor */
    getPayloadAgendaEscalaFornecedor = () => {
        const { kminicial, fotoKmInicial, kmfinal, fotoKmFinal } = this.state;

        const formData = new FormData();

        formData.append('kminicial', kminicial || '');
        formData.append('kmfinal', kmfinal || '');

        if (fotoKmInicial) {
            formData.append('fotokminicial', fotoKmInicial);
        }

        if (fotoKmFinal) {
            formData.append('fotokmfinal', fotoKmFinal);
        }

        return formData;
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { escala, kminicial, kmfinal } = this.state;
        const { history } = this.props;

        if ((kminicial && !kmfinal) || (!kminicial && kmfinal)) {
            this.handleOpenAlert('Obrigatório informar o KM inicial e o KM final para salvar!');

            return;
        }

        if (kminicial && kmfinal && Number(kmfinal) <= Number(kminicial)) {
            this.handleOpenAlert('KM final deve ser maior que o KM inicial!');

            return;
        }

        try {
            const formData = this.getPayloadAgendaEscalaFornecedor();

            await api.put(`/agendaescalafornecedor/${escala.coditemescala}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            history.push(this.getBaseRoute());
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para voltar */
    onClickVoltar = () => {
        this.props.history.push(this.getBaseRoute());
    };

    /* Muda os campos KM - somente dígitos */
    handleKmChange = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value.replace(/\D/g, '') });
    };

    /* Método para selecionar foto */
    handleFotoChange = (e) => {
        const { name, files } = e.target;

        if (files && files[0]) {
            this.setState({ [name]: files[0] });
        }
    };

    /* Abre o modal de visualização da foto */
    handleOpenImageModal = (src, alt) => {
        if (!src) return;

        this.setState({
            isImageModalOpen: true,
            imageModalSrc: src,
            imageModalAlt: alt || 'Imagem'
        });
    };

    /* Fecha o modal de visualização da foto */
    handleCloseImageModal = () => {
        this.setState({
            isImageModalOpen: false,
            imageModalSrc: '',
            imageModalAlt: ''
        });
    };

    /* Abre o modal de observação */
    handleOpenObsModal = (item) => {
        this.setState({
            openObsModal: true,
            obsModalTexto: item && item.obs ? item.obs : '',
            obsModalTitulo: item && item.coditemos ? `Observação OS ${item.nroos}` : 'Observação'
        });
    };

    /* Fecha o modal de observação */
    handleCloseObsModal = () => {
        this.setState({
            openObsModal: false,
            obsModalTexto: '',
            obsModalTitulo: ''
        });
    };

    /* Agrupa os itens por hotel */
    groupByHotel = (itens) => {
        const groups = {};

        (itens || []).forEach((item) => {
            const hotel = item.hotel || 'SEM HOTEL';

            if (!groups[hotel]) groups[hotel] = [];

            groups[hotel].push(item);
        });

        return groups;
    };

    /* Retorna a rota base */
    getBaseRoute = () => {
        const { match } = this.props;

        return match.path.startsWith('/admpartner')
            ? '/admpartner/agendaescalafornecedor'
            : '/partner/agendaescalafornecedor';
    };

    /* Abre o modal de passageiros */
    handleOpenPaxModal = async (item = null) => {
        const { escala } = this.state;

        try {
            const params = item ? `?coditemos=${item.coditemos}` : '';
            const response = await api.get(`/agendaescalafornecedor/${escala.coditemescala}/pax${params}`);
            const paxModalItens = response.data.data || [];

            this.setState({
                openPaxModal: true,
                paxModalItens,
                paxModalTotal: item ? item.totalpax : escala.totalpax,
                paxModalTitulo: item ? `OS ${item.nroos} - ${item.titular}` : `Escala ${escala.coditemescala}`,
                paxModalGeral: !item
            });
        } catch (error) {
            console.error('Erro ao carregar passageiros:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar passageiros!'
            );
        }
    };

    /* Fecha o modal de passageiros */
    handleClosePaxModal = () => {
        this.setState({
            openPaxModal: false,
            paxModalTitulo: '',
            paxModalTotal: 0,
            paxModalItens: [],
            paxModalGeral: false
        });
    };

    /* Agrupa os passageiros por OS */
    groupPaxByOS = (paxModalItens) => {
        const groups = {};

        (paxModalItens || []).forEach((pax) => {
            const key = pax.coditemos || pax.nroos;

            if (!groups[key]) {
                groups[key] = {
                    coditemos: pax.coditemos,
                    nroos: pax.nroos,
                    titular: pax.titular,
                    itens: []
                };
            }

            groups[key].itens.push(pax);
        });

        return Object.values(groups);
    };

    render() {
        const {
            configPartner,
            escala,
            fotoKmFinal,
            fotoKmInicial,
            imageModalAlt,
            imageModalSrc,
            isImageModalOpen,
            isLoading,
            isView,
            itens,
            kmfinal,
            kminicial,
            messageAlert,
            obsModalTexto,
            obsModalTitulo,
            openAlert,
            openObsModal,
            openPaxModal,
            paxModalItens,
            paxModalGeral,
            paxModalTitulo,
            paxModalTotal
        } = this.state;

        if (isLoading || !escala) {
            return (
                <div style={{ margin: 30 }}>
                    <Typography variant="body1">
                        Carregando...
                    </Typography>
                </div>
            );
        }

        const grupos = this.groupByHotel(itens);
        const hoteisOrdenados = Object.keys(grupos).sort((a, b) => a.localeCompare(b));

        const fotoKmInicialSrc = fotoKmInicial
            ? URL.createObjectURL(fotoKmInicial)
            : escala && escala.fotokminicial ? `data:image/jpeg;base64,${escala.fotokminicial}` : '';

        const fotoKmFinalSrc = fotoKmFinal
            ? URL.createObjectURL(fotoKmFinal)
            : escala && escala.fotokmfinal ? `data:image/jpeg;base64,${escala.fotokmfinal}` : '';

        const gruposPax = this.groupPaxByOS(paxModalItens);

        return (
            <div
                style={{
                    marginLeft: 30,
                    marginTop: 30,
                    marginRight: 30
                }}
            >
                <Card>
                    <CardContent>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            style={{
                                flexWrap: 'wrap',
                                gap: 12
                            }}
                        >
                            <Typography variant="h5">
                                Escala {escala.coditemescala}
                            </Typography>

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 10 }}
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.onClickVoltar}
                                >
                                    Voltar
                                </Button>

                                {!isView && (
                                    configPartner.informakminifim === ASIM || configPartner.registrafotokm === ASIM
                                ) && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.onClickSave}
                                        >
                                            Salvar
                                        </Button>
                                    )
                                }
                            </Box>
                        </Box>

                        <Divider style={{ marginTop: 12, marginBottom: 12 }} />

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            justifyContent="space-between"
                            style={{ gap: 12 }}
                        >
                            <Box
                                style={{
                                    flex: '0 1 220px',
                                    minWidth: 220,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Serviço
                                </Typography>

                                <Typography variant="body1">
                                    {escala.descservico}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    flex: '0 1 140px',
                                    minWidth: 140,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Data
                                </Typography>

                                <Typography variant="body1">
                                    {formatData(escala.dataservico)}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Hora Serviço
                                </Typography>

                                <Typography variant="body1">
                                    {formatTime(escala.horaservico)}
                                </Typography>
                            </Box>

                            <Box
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120,
                                    textAlign: 'center'
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Total Pax
                                </Typography>

                                <Typography variant="body1">
                                    <span
                                        onClick={() => this.handleOpenPaxModal()}
                                        style={{
                                            cursor: 'pointer',
                                            color: '#3f51b5',
                                            fontWeight: 500
                                        }}
                                    >
                                        {escala.totalpax}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>

                        <Divider style={{ marginTop: 8, marginBottom: 12 }} />

                        {/* Bloco configurações Partner */}
                        {
                            (
                                configPartner.informakminifim === ASIM ||
                                configPartner.registrafotokm === ASIM ||
                                configPartner.informadatahsfinal === ASIM
                            ) && (
                                <React.Fragment>
                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        style={{
                                            gap: 12,
                                            marginBottom: 16,
                                            marginTop: 16
                                        }}
                                    >
                                        {configPartner.informakminifim === ASIM && (
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="flex-end"
                                                style={{ gap: 8 }}
                                            >
                                                <TextField
                                                    label="KM inicial"
                                                    name="kminicial"
                                                    value={kminicial}
                                                    onChange={this.handleKmChange}
                                                    disabled={isView}
                                                    variant="outlined"
                                                    inputProps={{
                                                        inputMode: 'numeric',
                                                        pattern: '[0-9]*',
                                                        maxLength: 10
                                                    }}
                                                    style={{
                                                        minWidth: 120,
                                                        flex: '0 1 120px',
                                                        backgroundColor: isView ? '#f2f2f2' : 'transparent'
                                                    }}
                                                />

                                                {configPartner.registrafotokm === ASIM && (
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="center"
                                                    >
                                                        {!isView && (
                                                            <Tooltip title="Inserir foto KM inicial" enterDelay={50}>
                                                                <label>
                                                                    <CloudUploadOutlinedIcon
                                                                        onMouseEnter={(e) => {
                                                                            if (!fotoKmInicialSrc) e.currentTarget.style.color = '#1976d2';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (!fotoKmInicialSrc) e.currentTarget.style.color = '';
                                                                        }}
                                                                        color="primary"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            fontSize: 26,
                                                                            color: fotoKmInicialSrc ? '#43a047' : undefined
                                                                        }}
                                                                    />

                                                                    <input
                                                                        type="file"
                                                                        name="fotoKmInicial"
                                                                        accept="image/*"
                                                                        hidden
                                                                        onChange={this.handleFotoChange}
                                                                    />
                                                                </label>
                                                            </Tooltip>
                                                        )}

                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={!fotoKmInicialSrc}
                                                            onClick={(e) => {
                                                                e.currentTarget.blur();
                                                                this.handleOpenImageModal(fotoKmInicialSrc, 'Foto KM inicial');
                                                            }}
                                                            style={{
                                                                fontSize: 10,
                                                                color: fotoKmInicialSrc ? '#2e7d32' : undefined,
                                                                borderColor: fotoKmInicialSrc ? '#66bb6a' : undefined,
                                                                backgroundColor: fotoKmInicialSrc ? '#edf7ed' : undefined
                                                            }}
                                                        >
                                                            Visualizar
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}

                                        {configPartner.informakminifim === ASIM && (
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="flex-end"
                                                style={{ gap: 8 }}
                                            >
                                                <TextField
                                                    label="KM final"
                                                    name="kmfinal"
                                                    value={kmfinal}
                                                    onChange={this.handleKmChange}
                                                    disabled={isView}
                                                    variant="outlined"
                                                    inputProps={{
                                                        inputMode: 'numeric',
                                                        pattern: '[0-9]*',
                                                        maxLength: 10
                                                    }}
                                                    style={{
                                                        minWidth: 120,
                                                        flex: '0 1 120px',
                                                        backgroundColor: isView ? '#f2f2f2' : 'transparent'
                                                    }}
                                                />

                                                {configPartner.registrafotokm === ASIM && (
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        alignItems="center"
                                                    >
                                                        {!isView && (
                                                            <Tooltip title="Inserir foto KM final" enterDelay={50}>
                                                                <label>
                                                                    <CloudUploadOutlinedIcon
                                                                        onMouseEnter={(e) => {
                                                                            if (!fotoKmFinalSrc) e.currentTarget.style.color = '#1976d2';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            if (!fotoKmFinalSrc) e.currentTarget.style.color = '';
                                                                        }}
                                                                        color="primary"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            fontSize: 26,
                                                                            color: fotoKmFinalSrc ? '#43a047' : undefined
                                                                        }}
                                                                    />

                                                                    <input
                                                                        type="file"
                                                                        name="fotoKmFinal"
                                                                        accept="image/*"
                                                                        hidden
                                                                        onChange={this.handleFotoChange}
                                                                    />
                                                                </label>
                                                            </Tooltip>
                                                        )}

                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={!fotoKmFinalSrc}
                                                            onClick={(e) => {
                                                                e.currentTarget.blur();
                                                                this.handleOpenImageModal(fotoKmFinalSrc, 'Foto KM final');
                                                            }}
                                                            style={{
                                                                fontSize: 10,
                                                                color: fotoKmFinalSrc ? '#2e7d32' : undefined,
                                                                borderColor: fotoKmFinalSrc ? '#66bb6a' : undefined,
                                                                backgroundColor: fotoKmFinalSrc ? '#edf7ed' : undefined
                                                            }}
                                                        >
                                                            Visualizar
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Box>
                                        )}

                                        {configPartner.informadatahsfinal === ASIM && (
                                            <TextField
                                                label="Data final serviço"
                                                type="date"
                                                value={escala?.datafimservico ? escala.datafimservico.substring(0, 10) : ''}
                                                variant="outlined"
                                                disabled
                                                InputLabelProps={{ shrink: true }}
                                                style={{
                                                    minWidth: 150,
                                                    flex: '0 1 150px'
                                                }}
                                            />
                                        )}

                                        {configPartner.informadatahsfinal === ASIM && (
                                            <TextField
                                                label="Hora final serviço"
                                                type="time"
                                                value={escala?.horafimservico ? formatTime(escala.horafimservico) : ''}
                                                variant="outlined"
                                                disabled
                                                InputLabelProps={{ shrink: true }}
                                                style={{
                                                    minWidth: 120,
                                                    flex: '0 1 120px'
                                                }}
                                            />
                                        )}
                                    </Box>

                                    <Divider style={{ marginTop: 8, marginBottom: 12 }} />
                                </React.Fragment>
                            )
                        }

                        <Typography
                            variant="h6"
                            style={{ marginBottom: 10 }}
                        >
                            Ordens de Serviço Escaladas
                        </Typography>

                        {hoteisOrdenados.length === 0 ? (
                            <Typography variant="body2">
                                Nenhuma OS encontrada para essa escala
                            </Typography>
                        ) : (
                            hoteisOrdenados.map((hotel) => (
                                <Box
                                    key={hotel}
                                    style={{ marginBottom: 18 }}
                                >
                                    <Paper>
                                        <PerfectScrollBar>
                                            <div style={{ minWidth: 1200 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">OS</TableCell>

                                                            <TableCell align="center">Titular</TableCell>

                                                            <TableCell align="center">Total Pax</TableCell>

                                                            <TableCell align="center">Hotel</TableCell>

                                                            <TableCell align="center">Local Origem</TableCell>

                                                            <TableCell align="center">Local Destino</TableCell>

                                                            <TableCell align="center">Hora Apresentação</TableCell>

                                                            <TableCell align="center">Observação</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {grupos[hotel].map((item) => (
                                                            <TableRow
                                                                hover
                                                                key={item.nroos}
                                                            >
                                                                <TableCell align="center">
                                                                    {item.nroos}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.titular}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    <span
                                                                        onClick={() => this.handleOpenPaxModal(item)}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            color: '#3f51b5',
                                                                            fontWeight: 500
                                                                        }}
                                                                    >
                                                                        {item.totalpax}
                                                                    </span>
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.hotel}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.localorigem}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.localdestino}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {formatTime(item.horaapresentacao)}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {(() => {
                                                                        const semObs = !item.obs || item.obs.trim() === '';

                                                                        return (
                                                                            <Tooltip
                                                                                title={semObs ? '' : 'Observação'}
                                                                                enterDelay={50}
                                                                            >
                                                                                <span>
                                                                                    <FeedbackOutlinedIcon
                                                                                        onMouseEnter={(e) => {
                                                                                            if (!semObs) e.currentTarget.style.color = '#1976d2';
                                                                                        }}
                                                                                        onMouseLeave={(e) => {
                                                                                            if (!semObs) e.currentTarget.style.color = '#0000ee';
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (!semObs) this.handleOpenObsModal(item);
                                                                                        }}
                                                                                        style={{
                                                                                            cursor: semObs ? 'default' : 'pointer',
                                                                                            color: semObs ? '#bdbdbd' : '#0000ee'
                                                                                        }}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                                        );
                                                                    })()}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </PerfectScrollBar>
                                    </Paper>
                                </Box>
                            ))
                        )}
                    </CardContent>
                </Card>

                <Dialog
                    open={openObsModal}
                    onClose={this.handleCloseObsModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>{obsModalTitulo}</DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <FormGroup style={{ marginBottom: 8 }}>
                            <textarea
                                value={obsModalTexto}
                                readOnly
                                style={{
                                    height: 220,
                                    width: '100%',
                                    padding: 12,
                                    border: '1px solid #ccc',
                                    borderRadius: 6,
                                    fontFamily: 'Calibri, sans-serif',
                                    resize: 'none',
                                    overflowY: 'auto',
                                    cursor: 'default'
                                }}
                            />
                        </FormGroup>
                    </DialogContent>
                </Dialog>

                <Modal
                    open={isImageModalOpen}
                    onClose={this.handleCloseImageModal}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{ timeout: 500 }}
                >
                    <Fade in={isImageModalOpen}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '90vw',
                                height: '85vh',
                                maxWidth: 1040,
                                maxHeight: 585,
                                backgroundColor: 'transparent',
                                borderRadius: 12,
                                boxShadow: 'none',
                                border: 'none',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 0
                            }}
                        >
                            <img
                                src={imageModalSrc}
                                alt={imageModalAlt}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    borderRadius: '8px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </Fade>
                </Modal>

                <Dialog
                    open={openPaxModal}
                    onClose={this.handleClosePaxModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        <span
                            style={{
                                color: paxModalGeral ? '#000000' : '#3f51b5'
                            }}
                        >
                            {paxModalTitulo} - Total Pax: {paxModalTotal}
                        </span>
                    </DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        {paxModalItens.length === 0 && (
                            <Typography
                                variant="body2"
                                align="center"
                            >
                                Nenhum passageiro encontrado
                            </Typography>
                        )}

                        {paxModalGeral ? (
                            gruposPax.map((grupo) => (
                                <Box
                                    key={grupo.coditemos || grupo.nroos}
                                    style={{ marginBottom: 24 }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            color: '#3f51b5',
                                            fontWeight: 500,
                                            marginBottom: 8
                                        }}
                                    >
                                        OS {grupo.nroos} - {grupo.titular} - Total Pax: {grupo.itens.length}
                                    </Typography>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Passageiro</TableCell>
                                                <TableCell align="center">Tipo</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {grupo.itens.map((pax, index) => (
                                                <TableRow key={`${pax.coditemos}-${index}`}>
                                                    <TableCell>
                                                        {pax.nome}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {pax.tipo}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            ))
                        ) : (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Passageiro</TableCell>
                                        <TableCell align="center">Tipo</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paxModalItens.map((pax, index) => (
                                        <TableRow key={`${pax.coditemos}-${index}`}>
                                            <TableCell>
                                                {pax.nome}
                                            </TableCell>

                                            <TableCell align="center">
                                                {pax.tipo}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </DialogContent>
                </Dialog>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AgendaEscalaFornecedorForm;